<div class="visa-cont">
    <div class="d-flex align-items-center gap-3 flex-wrap justify-content-between">
        <div class="header-1  h-item ">
            <div class="border-c"></div>
            <h4 class="mb-0">Legal Compliance Information</h4>
        </div>
        <button mat-raised-button color="primary" type="button" *ngIf="isVisaRecord"
            class=" no-sh-btn  primary-btn d-flex  align-items-center " (click)="onEdit()">
            <img src="assets/images/icons/edit_without_bg.png" class="img-fluid me-1"
                alt="">{{"Edit"|translate}}</button>
        <button mat-raised-button color="primary" type="button" *ngIf="!isVisaRecord"
            class=" no-sh-btn  primary-btn d-flex  align-items-center " (click)="onEdit()">
            <i class="fas fa-plus text-white"></i> {{"COMMON.ADD"|translate}}</button>
    </div>
    <div *ngIf="isVisaRecord">
        <div class="row b-class py-2 mt-4">
            <div class="col-6 item-txt d-flex align-items-center ">{{"COMMON.STATUS"|translate}}</div>
            <div class="col-6">
                <div class="text-bold st-box  d-flex ">
                    <span class="active badge-c d-box" *ngIf="visaDetail.v_acp==1">{{"Accepted"|translate}}</span>
                    <span class="pending badge-c d-box" *ngIf="visaDetail.v_acp==2">{{"Pending"|translate}}</span>
                    <span class="un-attend   badge-c d-box" *ngIf="visaDetail.v_acp==0">{{"Rejected"|translate}}</span>
                </div>

            </div>
        </div>
        <div class="row b-class py-2">
            <div class="col-6 item-txt ">{{"EMPLOYEE.VISA.PASSPORTNO"|translate}}</div>
            <div class="col-6">{{visaDetail.passport_number}}</div>
        </div>
        <div class="row b-class py-2">
            <div class="col-6 item-txt ">{{"EMPLOYEE.VISA.VISAEXPIREDATE"|translate}}</div>
            <div class="col-6">{{visaDetail.ex_dt}}</div>
        </div>
        <div class="row b-class py-2">
            <div class="col-6 item-txt ">{{"EMPLOYEE.VISA.PERMITTEDHOUR"|translate}}</div>
            <div class="col-6">{{visaDetail.permitted_hour}}</div>
        </div>
        <div class="row b-class py-2">
            <div class="col-6 item-txt ">{{"EMPLOYEE.VISA.NATIONALITY"|translate}}</div>
            <div class="col-6">{{visaDetail.nationality}}</div>
        </div>
        <div class="row b-class py-2">
            <div class="col-6 item-txt ">{{"COMMON.NOTES"|translate}}</div>
            <div class="col-6">{{visaDetail.notes}}</div>
        </div>
        <div class="row b-class py-2">
            <div class="col-6 item-txt ">{{"EMPLOYEE.VISA.VISAIMAGE"|translate}}</div>
        </div>
        <div>
            <div class="custom-carousel">
                <button (click)="prevPass()" *ngIf="visibleItemsPass.length != 0" class="carousel-control-prev"
                    type="button">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <div class="carousel-inner" *ngIf="visibleItemsPass.length != 0">
                    <div class="carousel-item-container">
                        <div class="carousel-items slider-img" *ngFor="let item of visibleItemsPass;let i=index">
                            <div class="w-100 h-100">
                                <img #imgRef [src]="checkUrl(item.pass_img)"
                                     class="img-fluid " alt="...">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mat-table__message" *ngIf="visibleItemsPass.length == 0">
                    <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
                </div>
                <button *ngIf="visibleItemsPass.length != 0" (click)="nextPass()" class="carousel-control-next"
                    type="button">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
            </div>
        </div>
        <div class="row b-class py-2">
            <div class="col-6 item-txt ">{{"EMPLOYEE.VISA.PASSPORTIMAGES"|translate}}</div>
        </div>
        <div>
            <div class="custom-carousel">
                <button (click)="prev()" *ngIf="visibleItems.length != 0" class="carousel-control-prev" type="button">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <div class="carousel-inner" *ngIf="visibleItems.length != 0">
                    <div class="carousel-item-container">
                        <div class="carousel-items slider-img" *ngFor="let item of visibleItems;let i=index">
                            <div class="w-100 h-100">
                                <img #imgRef2 [src]="checkUrl(item?.image)"
                                     class="img-fluid "
                                    alt="...">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mat-table__message" *ngIf="visibleItems.length == 0">
                    <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
                </div>
                <button *ngIf="visibleItems.length != 0" (click)="next()" class="carousel-control-next" type="button">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
            </div>
        </div>
        <div class="ps-2">
            <strong>Note:</strong> You can change the status of legal compliance using the below action buttons.
        </div>
        <div class="mt-3 d-flex align-items-center justify-content-center">
            <button mat-raised-button color="warn" class="auth-form-btn  success-btn" type="submit"
                (click)="acceptReject('accept',1)">{{"BUTTON.ACCEPT"| translate}}</button>
            <button mat-raised-button color="warn" class="auth-form-btn  danger-btn ms-3" type="submit"
                (click)="acceptReject('reject',0)">{{"BUTTON.REJECT"| translate}}</button>
        </div>
    </div>
    <div class="mat-table__message" *ngIf="!isVisaRecord">
        <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
    </div>
</div>